import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {interval, Observable, throwError} from 'rxjs';
import {catchError, filter, map, switchMap, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FazerPedidoAvulsoService {

  public interval = 5_000;
  public readonly OK_STATUS_CODE = 200;
  public readonly ACCEPTED_STATUS_CODE = 202;
  public readonly CREATED_STATUS_CODE = 201;
  public readonly MAXIMO_TENTATIVAS = 50;

  constructor(private readonly http: HttpClient) {
  }

  public iniciarCalculos(companyId, listaUsuarios: any): Observable<string> {

    const body: string = JSON.stringify(listaUsuarios);

    return this.http.post<{
      status: string,
      activeOrderId: string
    }>(`/apiconnect/orders/calculations/companies/${companyId}/users/start`, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }), observe: 'response'
      }
    ).pipe(
      take(1),
      map(response => {
        if (response.status !== this.ACCEPTED_STATUS_CODE) {
          throw new Error(`Ocorreu um erro inesperado: ${response.status}`);
        }
        const activeOrderId = response.body?.activeOrderId;
        if (!activeOrderId) {
          throw new Error('O processo de cálculo da taxas não foi iniciado');
        }
        return activeOrderId;
      })
    );
  }

  public verificarDadosCalculados(companyId: string, activeOrderId: string): Observable<any> {
    return interval(this.interval).pipe(
      take(this.MAXIMO_TENTATIVAS),
      switchMap(() =>
        this.http.get<any>(
          `/apiconnect/orders/companies/${companyId}/orders-separated/${activeOrderId}/status`,
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }),
            observe: 'response'
          }
        )
      ),
      filter(response => response.status === this.CREATED_STATUS_CODE),
      take(1),
      map(response => response.body),
      catchError(error => throwError(() => error))
    );
  }
}
